import React, { useEffect } from 'react';

import HomeBanner from 'app/modules/admin/homeBanner/HomeBanner';
import { useHistory } from 'react-router-dom';
import useStore, { IStore } from 'app/store';
const Home: React.FC = () => {
    const setSearchOrigin = useStore((state: IStore) => state.setSearchOrigin);
    const history = useHistory();
    useEffect(() => {
        setSearchOrigin(history?.location?.pathname);
    }, []);
    return (
        <>
            <HomeBanner />
        </>
    );
};

export default Home;
